export default "__VITE_ASSET__C5JnNURc__"